import { render, staticRenderFns } from "./ExtraProjectDocumentation.vue?vue&type=template&id=97fd01e2&"
import script from "./ExtraProjectDocumentation.vue?vue&type=script&lang=js&"
export * from "./ExtraProjectDocumentation.vue?vue&type=script&lang=js&"
import style0 from "./ExtraProjectDocumentation.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports